module.exports = __webpack_public_path__ + "spine/Farm_Girl.json?eb306bb884fae139802d56f8c497259d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/citizens/girl/Farm_Girl.json
// module id = 1746
// module chunks = 3